export const ENV = process.env.REACT_APP_ENV
export const RSA_PUBLIC_KEY = process.env.REACT_APP_RSA_PUBLIC_KEY
export const API = process.env.REACT_APP_API